import React, { createContext, useContext, useState, useEffect } from 'react';
import { clearApiDataCache, getLibraries, getTenantSessionScope } from '../api/api1';
import { clearServiceApiCache } from '../services/api';

const LibraryContext = createContext();

export const useLibrary = () => useContext(LibraryContext);

export const LibraryProvider = ({ children }) => {
  const [selectedLibrary, setSelectedLibrary] = useState(() => {
    const scope = getTenantSessionScope();
    if (localStorage.getItem('selectedLibraryScope') !== scope) {
      localStorage.removeItem('selectedLibrary');
      localStorage.removeItem('selectedLibraryId');
      localStorage.setItem('selectedLibraryScope', scope);
      return '';
    }
    const savedLibrary = localStorage.getItem('selectedLibrary');
    return savedLibrary && savedLibrary !== 'All Libraries' ? savedLibrary : '';
  });
  const [libraries, setLibraries] = useState([]);
  const [librariesLoading, setLibrariesLoading] = useState(true);

  const refreshLibraries = async () => {
    try {
      const data = await getLibraries();
      setLibraries(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Failed to fetch libraries', error);
      setLibraries([]);
    }
  };

  useEffect(() => {
    let cancelled = false;

    const fetchLibraries = async () => {
      setLibrariesLoading(true);
      try {
        const data = await getLibraries();
        if (!cancelled) {
          setLibraries(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        if (!cancelled) {
          console.error('Failed to fetch libraries', error);
          setLibraries([]);
        }
      } finally {
        if (!cancelled) setLibrariesLoading(false);
      }
    };

    fetchLibraries();
    const handleLibraryChange = () => {
      clearApiDataCache();
      clearServiceApiCache();
      fetchLibraries();
    };
    window.addEventListener('libraryChange', handleLibraryChange);
    return () => {
      cancelled = true;
      window.removeEventListener('libraryChange', handleLibraryChange);
    };
  }, []);

  const handleSetSelectedLibrary = (lib) => {
    const value = lib === 'All Libraries' || lib === 'all' ? '' : lib;
    localStorage.setItem('selectedLibraryScope', getTenantSessionScope());
    localStorage.setItem('selectedLibrary', value);
    setSelectedLibrary(value);
  };

  return (
    <LibraryContext.Provider value={{
      selectedLibrary,
      setSelectedLibrary: handleSetSelectedLibrary,
      libraries,
      librariesLoading,
      refreshLibraries,
    }}>
      {children}
    </LibraryContext.Provider>
  );
};
